import { hasWindow } from "@omni/utils/dom.utils";
import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";
import { GroupBase } from "react-select";
import { default as ReactCreatableSelect } from "react-select/creatable";

type Props<
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = ComponentProps<typeof ReactCreatableSelect<Option, IsMulti, Group>> & {
    isInvalid?: boolean;
    isValid?: boolean;
};

export const CreatableSelect = <
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    className,
    isInvalid = false,
    isValid = false,
    ...props
}: Props<Option, IsMulti, Group>) => {
    return (
        <div
            className={cn(
                "tw:flex tw:bg-background tw:border tw:border-grey-input tw:transition-shadow",
                "tw:focus-within:ring-inset tw:focus-within:ring-3 tw:focus-within:ring-information/40 tw:focus-within:border-information tw:focus-visible:outline-none! tw:focus-within:z-10 tw:focus-visible:z-10",
                "tw:rounded-sm!",
                "tw:group-[*]/inputgroup:not-first:rounded-l-none!",
                "tw:group-[*]/inputgroup:not-last:rounded-r-none!",
                "tw:group-[*]/inputgroup:not-last:-mr-px!",
                {
                    "tw:border-danger! tw:ring-danger/40!": isInvalid,
                    "tw:border-success! tw:ring-success/40!": isValid
                },
                className
            )}
        >
            <ReactCreatableSelect<Option, IsMulti, Group>
                {...props}
                menuPortalTarget={hasWindow() ? document.body : undefined}
                classNames={{
                    control: () =>
                        "tw:h-10! tw:border-none! tw:shadow-none! tw:bg-transparent! tw:gap-2!",
                    container: () => "tw:w-full",
                    input: () => "input-select",
                    valueContainer: () => "tw:pr-0!",
                    clearIndicator: () => "tw:pl-0!",
                    loadingIndicator: () => "tw:pl-0!",
                    dropdownIndicator: () => "tw:pl-0!",
                    indicatorSeparator: () => "tw:mr-2",
                    menuList: () => "tw:p-0!",
                    menu: () => "tw:overflow-hidden!",
                    menuPortal: () => "tw:z-10!"
                }}
            />
        </div>
    );
};
